var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSharesClosed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 73,
    viewBox: "0 0 67 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2975 22.6349L3.39486 27.6133C2.64661 27.6787 2.09311 28.3384 2.15857 29.0866L5.77379 70.4088C5.83925 71.157 6.4989 71.7105 7.24715 71.6451L64.1498 66.6667C64.898 66.6013 65.4515 65.9416 65.3861 65.1934L61.7709 23.8712C61.7054 23.123 61.0458 22.5695 60.2975 22.6349Z",
    fill: "white",
    stroke: "#1F64E7",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1106 64.9136L10.3676 68.3004C9.61933 68.3659 8.95969 67.8123 8.89422 67.0641L6.04663 34.5337C16.8938 48.5903 31.8474 59.3158 49.1106 64.9136Z",
    fill: "#E8F0FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8243 33.675C37.0795 31.731 44.5369 36.0365 46.4809 43.2917C48.4249 50.5468 44.1194 58.0042 36.8642 59.9482C29.6091 61.8922 22.1517 57.5867 20.2077 50.3315C18.2637 43.0764 22.5692 35.619 29.8243 33.675ZM40.2867 39.3912L30.7548 55.9023C32.3801 56.3441 34.1404 56.375 35.8846 55.9076C41.1446 54.4982 44.2661 49.0916 42.8567 43.8316C42.3893 42.0872 41.4823 40.578 40.2867 39.3912ZM30.7807 36.8596C25.5208 38.269 22.3993 43.6756 23.8087 48.9356C24.2745 50.674 25.1769 52.1789 26.3664 53.3638L35.8952 36.8607C34.2742 36.4229 32.5194 36.3937 30.7807 36.8596Z",
    fill: "#E8F0FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9663 39.5667L31.1044 56.6466C32.7861 57.104 34.6075 57.136 36.4123 56.6525C41.8537 55.1944 45.0828 49.6014 43.6248 44.1601C43.1413 42.3556 42.203 40.7944 40.9663 39.5667ZM31.1324 36.9476C25.691 38.4056 22.4619 43.9986 23.9199 49.44C24.3829 51.1678 25.2628 52.6726 26.4224 53.8751L36.2254 36.8974C34.604 36.4942 32.8605 36.4845 31.1324 36.9476Z",
    stroke: "#1F64E7",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8132 33.6004C41.6943 34.0707 42.5281 34.6283 43.3005 35.2653M45.0212 36.9327C46.4904 38.6051 47.6074 40.6323 48.2226 42.9281C50.361 50.9087 45.6249 59.1118 37.6442 61.2502C29.6636 63.3887 21.4605 58.6526 19.3221 50.6719C17.1836 42.6913 21.9197 34.4882 29.9004 32.3498C32.7675 31.5815 35.6634 31.7005 38.2965 32.5386",
    stroke: "#1F64E7",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4498 4.18558C34.8798 4.79462 35.1323 5.53782 35.1323 6.34001C35.1323 8.40556 33.4579 10.08 31.3923 10.08C29.3268 10.08 27.6523 8.40556 27.6523 6.34001C27.6523 5.53782 27.9049 4.79462 28.3348 4.18558C28.333 4.22374 28.3323 4.26179 28.3323 4.30001C28.3323 5.99 29.7024 7.36001 31.3923 7.36001C33.0823 7.36001 34.4523 5.99 34.4523 4.30001L34.4498 4.18558Z",
    fill: "#E8F0FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06396 23.5039L10.5242 21.307M12.3162 19.7067L28.3423 5.39548M36.2555 7.31578L55.9289 19.3163",
    stroke: "#75A4FE",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3923 7.36001C33.0823 7.36001 34.4523 5.99 34.4523 4.30001C34.4523 2.61001 33.0823 1.24001 31.3923 1.24001C29.7023 1.24001 28.3323 2.61001 28.3323 4.30001C28.3323 5.99 29.7023 7.36001 31.3923 7.36001Z",
    stroke: "#1F64E7",
    strokeWidth: 2.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharesClosed);
export default __webpack_public_path__ + "static/media/shares-closed.d59d16bb937e890c0da9460cb9720f09.svg";
export { ForwardRef as ReactComponent };